// ==========================================================
// Catálogo de tutoriales — fuente única para la biblioteca (22b),
// el reproductor (22a) y el submenú del sidebar.
//
// Para añadir un tutorial basta con agregarlo aquí: la ruta
// /tutoriales/<slug> lo resuelve sola.
// ==========================================================

export const TUTORIALES = [
  {
    slug: 'introduccion-licitahub',
    title: 'Configurar tu cuenta',
    category: 'Introducción a LicitaHub',
    duration: '2:46',
    views: 100,
    level: 'Básico',
    videoId: 'WVlwHfZoYOQ',
    description:
      'Aprende a configurar tu cuenta y las alertas por correo para recibir las nuevas convocatorias que te interesan.',
    learningPoints: [
      'Configurar tu perfil de usuario y tus rubros',
      'Activar las alertas por correo'
    ],
    // disponible: false → se muestra el material pero sin enlace (el archivo aún no está publicado)
    resources: [
      { title: 'Guía de inicio rápido', url: '/guias/inicio-rapido.pdf', tipo: 'pdf', peso: 'PDF', disponible: false },
      { title: 'Manual de usuario', url: '/manuales/usuario-completo.pdf', tipo: 'manual', peso: 'PDF', disponible: false }
    ],
    tip: 'Después de este video, configura tus alertas en Preferencias, dentro del menú de tu cuenta.'
  },
  {
    slug: 'vista-general-estadisticas',
    title: 'Vista General y Estadísticas',
    category: 'Introducción a LicitaHub',
    duration: null,
    views: null,
    level: 'Básico',
    videoId: 'T-TycGgEr6s',
    description: 'Conoce la vista general y las estadísticas de LicitaHub.',
    learningPoints: [
      'Conocer la vista general de LicitaHub',
      'Consultar las estadísticas de la plataforma'
    ],
    resources: []
  },
  {
    slug: 'procesos-menores-8-uit',
    title: 'Contratos Menores',
    category: 'Contratos Menores',
    duration: null,
    views: null,
    level: 'Básico',
    videoId: '0X0E24l6POw',
    description:
      'Aprenderás a utilizar los filtros avanzados de la plataforma para encontrar procesos de contratación menores a 8 UIT. Paso a paso: cómo configurar los filtros, interpretar los resultados y optimizar tu búsqueda para encontrar las mejores oportunidades.',
    learningPoints: [
      'Cómo acceder a la sección de Contratos Menores',
      'Configurar filtros por monto (menor a 8 UIT)',
      'Interpretar los resultados de búsqueda',
      'Guardar y exportar resultados',
      'Configurar alertas para nuevos procesos'
    ],
    resources: [
      { title: 'Guía: Contratos Menores', url: '/guias/contratos-menores.pdf', tipo: 'pdf', peso: 'PDF', disponible: false },
      { title: 'Plantilla de filtros', url: '/plantillas/filtros-menores.xlsx', tipo: 'excel', peso: 'XLSX', disponible: false }
    ]
  },
  {
    slug: 'busqueda-avanzada-seace',
    title: 'Convocatorias del SEACE',
    category: 'SEACE',
    duration: null,
    views: null,
    level: 'Intermedio',
    videoId: 'fsB5KWzeYIw',
    description:
      'Domina las técnicas avanzadas de búsqueda en el Sistema Electrónico de Contrataciones del Estado. Aprende los criterios para encontrar exactamente lo que necesitas.',
    learningPoints: [
      'Utilizar LicitaHUB — SEACE',
      'Filtros por entidad, región y tipo de proceso',
      'Búsquedas por palabras clave',
      'Combinación de múltiples criterios'
    ],
    resources: [
      { title: 'Manual SEACE avanzado', url: '/manuales/seace-avanzado.pdf', tipo: 'manual', peso: 'PDF', disponible: false },
      { title: 'Plantilla de búsqueda', url: '/plantillas/busqueda-seace.xlsx', tipo: 'excel', peso: 'XLSX', disponible: false },
      { title: 'Operadores booleanos', url: '/guias/operadores-booleanos.pdf', tipo: 'pdf', peso: 'PDF', disponible: false }
    ]
  },
  {
    slug: 'seguimiento-convocatorias',
    title: 'Seguimiento de convocatorias',
    category: 'Seguimiento de convocatorias',
    duration: null,
    views: null,
    level: 'Básico',
    videoId: 'Ge4ZapUZKVc',
    description:
      'Guarda las convocatorias que te interesan en tu calendario y sigue su avance desde el tablero: los hitos de cada proceso y la etapa comercial en la que está.',
    learningPoints: [
      'Guardar una convocatoria en el calendario desde SEACE o Contratos Menores',
      'Consultar los hitos del proceso en la agenda y en la vista de mes',
      'Mover una convocatoria entre etapas en el tablero de seguimiento'
    ],
    resources: []
  },
  // ⚠️ Este venía del listado anterior de Tutoriales.js y se conserva para no
  // perder nada. Si resulta ser la versión antigua de uno de los de arriba, basta con
  // borrar su entrada aquí y desaparece de la biblioteca.
  {
    slug: 'procesos-mayores-seace',
    title: 'Cómo buscar procesos mayores en SEACE',
    category: 'SEACE',
    duration: '8:45',
    views: 892,
    level: 'Intermedio',
    videoId: 'WQhuFnyl_h8',
    description: 'Aprende cómo LicitaHUB te ayuda a encontrar oportunidades del SEACE.',
    learningPoints: [],
    resources: []
  },
  {
    slug: 'plan-anual-contrataciones',
    title: 'Oportunidades en el Plan Anual de Contrataciones (PAC)',
    category: 'PAC',
    duration: '6:15',
    views: 2100,
    level: 'Básico',
    videoId: 'dQw4w9WgXcQ',
    description:
      'Guía completa para navegar y utilizar el Plan Anual de Contrataciones de manera eficiente.',
    learningPoints: [],
    resources: []
  },
  {
    slug: 'registro-proveedores',
    title: 'Registro de proveedores',
    category: 'Proveedores',
    duration: '4:20',
    views: 756,
    level: 'Básico',
    videoId: 'dQw4w9WgXcQ',
    description:
      'Proceso paso a paso para registrarse como proveedor en nuestro catálogo de servicios.',
    learningPoints: [],
    resources: []
  }
];

// Rutas de aprendizaje: agrupan tutoriales existentes en un orden con sentido
export const RUTAS = [
  {
    id: 'primeros-pasos',
    nombre: 'Introducción a LicitaHub',
    icono: 'rocket',
    descripcion: 'Configura tu cuenta y conoce la vista general y las estadísticas de la plataforma.',
    slugs: ['introduccion-licitahub', 'vista-general-estadisticas']
  },
  {
    id: 'buscar-oportunidades',
    nombre: 'Buscar oportunidades',
    icono: 'search',
    descripcion: 'Filtros, palabras clave y búsqueda avanzada en el SEACE y el PAC.',
    slugs: ['procesos-menores-8-uit', 'busqueda-avanzada-seace', 'plan-anual-contrataciones']
  }
];

export const porSlug = (slug) => TUTORIALES.find((t) => t.slug === slug) || null;

export const rutaDe = (slug) => RUTAS.find((r) => r.slugs.includes(slug)) || null;

export const tutorialesDeRuta = (ruta) =>
  (ruta?.slugs || []).map(porSlug).filter(Boolean);

export const miniatura = (videoId) => `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

// "7:01" → 421 segundos
export const duracionEnSegundos = (duration) => {
  const partes = String(duration || '')
    .split(':')
    .map((n) => Number(n) || 0);
  if (partes.length === 3) return partes[0] * 3600 + partes[1] * 60 + partes[2];
  if (partes.length === 2) return partes[0] * 60 + partes[1];
  return partes[0] || 0;
};

// 6480 → "1 h 48 min"
export const formatoLargo = (segundos) => {
  const h = Math.floor(segundos / 3600);
  const m = Math.round((segundos % 3600) / 60);
  if (h > 0) return `${h} h ${m} min`;
  return `${m} min`;
};

// ==========================================================
// Progreso: vive solo en el navegador del usuario
// { [slug]: { pct: 0-100, visto: bool, ts: epoch } }
// ==========================================================
const PROGRESO_KEY = 'nuvia:tutoriales:progreso';

export const leerProgreso = () => {
  try {
    const raw = window.localStorage.getItem(PROGRESO_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (e) {
    return {};
  }
};

export const escribirProgreso = (progreso) => {
  try {
    window.localStorage.setItem(PROGRESO_KEY, JSON.stringify(progreso));
  } catch (e) {
    console.warn('No se pudo guardar el progreso de tutoriales:', e);
  }
  return progreso;
};

export const actualizarProgreso = (slug, parche) => {
  const actual = leerProgreso();
  const previo = actual[slug] || { pct: 0, visto: false };
  const siguiente = { ...previo, ...parche, ts: Date.now() };
  // el porcentaje nunca retrocede: refleja lo más lejos que llegó el usuario
  if (typeof previo.pct === 'number' && typeof siguiente.pct === 'number') {
    siguiente.pct = Math.max(previo.pct, siguiente.pct);
  }
  if (siguiente.visto) siguiente.pct = 100;
  return escribirProgreso({ ...actual, [slug]: siguiente });
};

// 'visto' | 'medias' | 'nuevo'
export const estadoDe = (progreso, slug) => {
  const p = progreso[slug];
  if (!p) return 'nuevo';
  if (p.visto || p.pct >= 95) return 'visto';
  if (p.pct > 0) return 'medias';
  return 'nuevo';
};

export const progresoDeRuta = (progreso, ruta) => {
  const slugs = ruta?.slugs || [];
  const hechos = slugs.filter((s) => estadoDe(progreso, s) === 'visto').length;
  return { hechos, total: slugs.length, pct: slugs.length ? (hechos / slugs.length) * 100 : 0 };
};

// Último tutorial empezado y no terminado, para "Continuar donde quedé"
export const continuarCon = (progreso) => {
  const pendientes = TUTORIALES.filter((t) => estadoDe(progreso, t.slug) === 'medias').sort(
    (a, b) => (progreso[b.slug]?.ts || 0) - (progreso[a.slug]?.ts || 0)
  );
  if (pendientes.length) return pendientes[0];
  return TUTORIALES.find((t) => estadoDe(progreso, t.slug) === 'nuevo') || TUTORIALES[0] || null;
};

// ==========================================================
// API IFrame de YouTube: se carga una sola vez y bajo demanda.
// Si no carga, el reproductor cae a un <iframe> normal.
// ==========================================================
let ytPromesa = null;

export const cargarYouTubeAPI = () => {
  if (typeof window === 'undefined') return Promise.reject(new Error('sin window'));
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (ytPromesa) return ytPromesa;

  ytPromesa = new Promise((resolve, reject) => {
    const anterior = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof anterior === 'function') anterior();
      resolve(window.YT);
    };
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.async = true;
    script.onerror = () => reject(new Error('No se pudo cargar el reproductor de YouTube'));
    document.head.appendChild(script);
    setTimeout(() => {
      if (!(window.YT && window.YT.Player)) reject(new Error('Tiempo de espera agotado'));
    }, 5000);
  });

  return ytPromesa;
};
